import { LocalizationContext } from '@hrworks/localization';
import { Divider } from '@hrworks/sui-core/Section';
import { StreamlineIcon } from '@hrworks/sui-core/StreamlineIcon';
import { observer } from 'mobx-react';
import { useContext } from 'react';

import { S } from './Sidebar.styles';
import type { SidebarProps } from './Sidebar.types';

export const Sidebar = observer(
  ({
    children,
    logo,
    upperSidebarChildren,
    brandingElement,
    showUpperSidebarChildren,
    continueAsAdminUrl,
    ...otherProps
  }: SidebarProps) => {
    const { translate } = useContext(LocalizationContext);

    return (
      <S.Container {...otherProps}>
        {brandingElement}
        <S.Scroller>
          {!!upperSidebarChildren && !!showUpperSidebarChildren && (
            <S.UpperSidebarChildrenContainer>
              {upperSidebarChildren}
              <Divider />
            </S.UpperSidebarChildrenContainer>
          )}
          {children}
        </S.Scroller>
        {continueAsAdminUrl && (
          <S.AdminButtonWrapper>
            <S.AdminButton
              href={continueAsAdminUrl}
              target="_blank"
              variant="subtle"
              rightIcon={<StreamlineIcon name="direction-right" />}
            >
              {translate('continue-as-admin')}
            </S.AdminButton>
          </S.AdminButtonWrapper>
        )}
      </S.Container>
    );
  },
);
